import { createSlice } from '@reduxjs/toolkit';
import { LATEST_VIEWED_PROJECT_ID } from 'src/shared/constants';
import { menuItemsProducts } from 'src/components/Menu/menuItems';

const localProjectId = localStorage.getItem(LATEST_VIEWED_PROJECT_ID);

const searchParams = new URLSearchParams(window.location.search);
const searchProjectType = searchParams.get('type');

const initialState = {
  projectId: +localProjectId || null,
  projectType: searchProjectType || null,
  products: menuItemsProducts,
};

export const projectsSlices = createSlice({
  name: 'projectsSlices',
  initialState,
  reducers: {
    setProjectId(state, action) {
      state.projectId = action.payload.projectId;
      state.projectType = action.payload?.projectType;
    },
    setProducts(state, action) {
      state.products = action.payload.products;
    },
  },
});

export const { setProjectId, setProducts } = projectsSlices.actions;

export default projectsSlices.reducer;
